var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamification4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.661,
    height: 21.601,
    viewBox: "0 0 40.661 21.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "business-people",
    transform: "translate(0 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21712",
    "data-name": "Path 21712",
    d: "M10.447,31.165A4.452,4.452,0,0,1,6,26.718V25.447a4.447,4.447,0,0,1,8.895,0v1.271a4.464,4.464,0,0,1-2.224,3.852.635.635,0,1,1-.635-1.1,3.19,3.19,0,0,0,1.588-2.752V25.447a3.177,3.177,0,1,0-6.353,0v1.271a3.18,3.18,0,0,0,3.177,3.177.635.635,0,0,1,0,1.271Z",
    transform: "translate(-2.188 -2.188)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21713",
    "data-name": "Path 21713",
    d: "M15.883,44.986a.635.635,0,0,1-.635-.635V41.669a1.888,1.888,0,0,0-1.431-1.846,23.783,23.783,0,0,0-5.557-.554,23.783,23.783,0,0,0-5.557.554,1.888,1.888,0,0,0-1.431,1.846v2.682a.635.635,0,1,1-1.271,0V41.669a3.158,3.158,0,0,1,2.4-3.081A25.079,25.079,0,0,1,8.259,38a25.079,25.079,0,0,1,5.861.59,3.158,3.158,0,0,1,2.4,3.081v2.682A.635.635,0,0,1,15.883,44.986Z",
    transform: "translate(0 -8.385)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21714",
    "data-name": "Path 21714",
    d: "M29.447,25.165A4.452,4.452,0,0,1,25,20.718V19.447a4.447,4.447,0,0,1,8.895,0v1.271a4.452,4.452,0,0,1-4.447,4.447Zm0-8.895a3.18,3.18,0,0,0-3.177,3.177v1.271a3.177,3.177,0,0,0,6.353,0V19.447A3.18,3.18,0,0,0,29.447,16.271Z",
    transform: "translate(-9.117 0)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21715",
    "data-name": "Path 21715",
    d: "M20.047,35.174a.635.635,0,0,1-.572-.916,3.141,3.141,0,0,1,2.07-1.67A25.079,25.079,0,0,1,27.409,32a25.079,25.079,0,0,1,5.861.59,3.141,3.141,0,0,1,2.071,1.671.637.637,0,1,1-1.144.56,1.87,1.87,0,0,0-1.234-1,23.784,23.784,0,0,0-5.554-.554,23.783,23.783,0,0,0-5.557.554,1.871,1.871,0,0,0-1.234,1A.635.635,0,0,1,20.047,35.174Z",
    transform: "translate(-7.078 -6.197)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21716",
    "data-name": "Path 21716",
    d: "M48.447,31.165a.635.635,0,0,1,0-1.271,3.18,3.18,0,0,0,3.177-3.177V25.447a3.177,3.177,0,0,0-6.353,0v1.271a3.19,3.19,0,0,0,1.588,2.752.635.635,0,1,1-.635,1.1A4.464,4.464,0,0,1,44,26.718V25.447a4.447,4.447,0,0,1,8.895,0v1.271A4.452,4.452,0,0,1,48.447,31.165Z",
    transform: "translate(-16.046 -2.188)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21717",
    "data-name": "Path 21717",
    d: "M53.883,44.986a.635.635,0,0,1-.635-.635V41.669a1.888,1.888,0,0,0-1.431-1.846,23.783,23.783,0,0,0-5.557-.554,23.783,23.783,0,0,0-5.557.554,1.888,1.888,0,0,0-1.431,1.846v2.682a.635.635,0,0,1-1.271,0V41.669a3.158,3.158,0,0,1,2.4-3.081A25.079,25.079,0,0,1,46.259,38a25.08,25.08,0,0,1,5.861.59,3.158,3.158,0,0,1,2.4,3.081v2.682A.635.635,0,0,1,53.883,44.986Z",
    transform: "translate(-13.858 -8.385)",
    fill: "#7fb1b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamification4);
export default __webpack_public_path__ + "static/media/gamification_4.11736deb.svg";
export { ForwardRef as ReactComponent };